import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";
import Swal from 'sweetalert2';

import {
    CREATE_PURCHASE_ORDER_SUCCESS,
    FETCH_PURCHASE_ORDER_SUCCESS,
    GET_ALL_UOM_IN_PO_SUCCESS, GET_ASSET_PURCHASE_REPORT_SUCCESS, GET_GLOBAL_PARAMETER_PO_SEARCH_SUCCESS, GET_GLOBAL_PARAMETER_SEARCH_SUCCESS,
    GET_PURCHASE_ORDER_SUCCESS,
    SAVE_PURCHASE_ORDER_QUERY,
    UNMOUNT_PURCHASE_ORDER_SUCCESS
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchGlobalSearchEnd, fetchGlobalSearchStart, fetchStart, fetchSuccess } from "./Common";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
    return {
        type: GET_PURCHASE_ORDER_SUCCESS,
        data,
        count
    };
};

export const saveResourceQuery = (query) => {
    return {
        type: SAVE_PURCHASE_ORDER_QUERY,
        query
    };
};

export const createResourceSuccess = ({ data }) => {
    return {
        type: CREATE_PURCHASE_ORDER_SUCCESS,
        data
    };
};

export const fetchResourceSuccess = ({ data }) => {
    return {
        type: FETCH_PURCHASE_ORDER_SUCCESS,
        data
    };
};

export const unmountPurchaseOrder = () => {
    return {
        type: UNMOUNT_PURCHASE_ORDER_SUCCESS,
    }
};

export const getAllUOMSuccess = ({ data }) => {
    return {
        type: GET_ALL_UOM_IN_PO_SUCCESS,
        data,
    };
};

export const getResource = () => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const { purchaseOrder } = store.getState();
            const { query } = purchaseOrder;
            const response = await axios.get(`/purchase-order?${generateQueryString(query)}`);
            dispatch(fetchSuccess());
            dispatch(getResourceSuccess(response.data));
        } catch (error) {
            // message.error(error.response.data.message);
            message.error("Record not found");
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const getResourceForDownload = (columns, filters, name) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const { purchaseOrder } = store.getState();
            const { query } = purchaseOrder;
            const response = await axios.get(`/purchase-order/download?columns=${columns}&${generateQueryString(query)}`);
            const finalResponse = [];
            response && response['data'] && response['data'].length && await Promise.all(response['data'].map(async (data) => {
                let rate = 0;
                if (data && data.assets && data.assets.length) {
                    await data.assets.map((asset) => {
                        rate = rate + asset.rate;
                    });
                } else if (data && data.spareParts && data.spareParts.length) {
                    await data.spareParts.map((spare) => {
                        rate = rate + (spare.rate * spare.quantity);
                    });
                }
                Object.assign(data, { totalAmount: rate });
                finalResponse.push(data);
                // Object.assign(response && response['data'], { totalAmount: rate});
            }));
            dispatch(fetchSuccess());
            if (columns.includes('totalAmount')) {
                let totalAmount = {
                    totalAmount: {
                        field: 'type',
                        type: "String",
                    }
                }
                Object.assign(filters, totalAmount);
            }
            columns = JSON.parse(columns);
            if (columns.includes("piNo")) {
                columns = columns.filter(item => item !== 'piNo');
                columns.push('poNo');
            }
            columns = JSON.stringify(columns);
            // const str = arrayToCSV(response.data, filters, columns);
            const str = arrayToCSV(finalResponse, filters, columns);
            downloadCSV(str, name);
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const getAllUOM = () => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.get(`/unit-of-measurement/get-all`);
            dispatch(fetchSuccess());
            dispatch(getAllUOMSuccess(response));
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log('Error****:', error.response.data.message);
        }
    };
};

export const createResource = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());

        try {
            let formData = new FormData();
            const documentData = [];
            payload.documents.map((item, index) => {
                formData.append('files', item.file);
                let data = { ...item };
                delete data.file;
                documentData.push(data)
            });
            const assets = [];
            payload.assets && payload.assets.map((item, index) => {
                let data = { ...item };
                if (!data.client) {
                    delete data.client;
                }
                assets.push(data);
            });

            formData.append('documentData', JSON.stringify(documentData));
            if (assets.length) {
                formData.append('assets', JSON.stringify(assets));
            }
            if (payload.spareParts && payload.spareParts.length) {
                formData.append('spareParts', JSON.stringify(payload.spareParts));
            }

            Object.keys(payload).forEach(key => {
                if (key === 'documents') {
                    return
                }
                if (key === 'assets') {
                    return
                }
                if (key === 'spareParts') {
                    return
                }
                if (key === 'orderNumber' && (payload[key] === null || payload[key] === undefined)) {
                    return
                }
                if (key === 'orderDate' && (payload[key] === null || payload[key] === undefined)) {
                    return
                }
                if (key === 'grnNo' && (payload[key] === null || payload[key] === undefined)) {
                    return
                }
                formData.append(key, payload[key]);
            });

            const response = await axios.post(`/purchase-order`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            if (response.data && response.data.code === 404) {
                dispatch(fetchSuccess());
                return message.error(response.data.message);
            }

            dispatch(fetchSuccess());
            dispatch(createResourceSuccess({ data: response.data }));
            const po = response.data;
            const poData = po.assets;
            let htmlData = '';
            for (let i = 0; i < poData.length; i++) {
                let dAsset = poData[i];
                htmlData += `<div> Assets </div>`
                htmlData += `<div style="text-align: left; border: 1px solid #000000; margin-bottom: 5px; padding: 10px; ${i === 0 ? 'margin-top: 20px' : ''} ">Asset Code - ${poData[i].asset.assetCode}
<br> Sub Asset Type - ${poData[i].asset.equipmentSubType.name} <br> Asset Model - ${poData[i].asset.assetModel.name} <br> Location - ${poData[i].location.name}
<br> Asset Type - ${poData[i].asset.equipmentSubType.assetType.name} <br> Owner - ${poData[i].asset.owner.name}
<br> ${(poData[i].client && 'Sub Location -') || ''} ${(poData[i].client && poData[i].client.name) || ''}</div>`
                for (let j = 0; j < dAsset.dependentAsset.length; j++) {
                    let sAsset = dAsset.dependentAsset[j];
                    if (j === 0) {
                        htmlData += `<div> Dependent Assets </div>`
                    }
                    htmlData += `<div style="text-align: left; border: 1px solid #000000; margin-bottom: 5px; padding: 10px; ${i === 0 ? 'margin-top: 20px' : ''} ">
Asset Code - ${sAsset.assetCode} <br> Sub Asset Type - ${sAsset.equipmentSubType.name} <br> Asset Model - ${sAsset.assetModel.name} <br> Location - ${poData[i].location.name}
<br> Owner - ${sAsset.owner.name} <br> ${(poData[i].client && 'Sub Location -') || ''} ${(poData[i].client && poData[i].client.name) || ''}</div>`
                }
                const subAssets = (dAsset && dAsset.subAssets) || [];
                for (let k = 0; k < subAssets.length; k++) {
                    const subEntry = subAssets[k] || {};
                    const subAsset = subEntry.asset || {};
                    if (k === 0) {
                        htmlData += `<div> Sub Assets </div>`
                    }
                    htmlData += `<div style="text-align: left; border: 1px solid #52c41a; margin-bottom: 5px; padding: 10px;">
Asset Code - ${subAsset.assetCode || '-'} <br> Sub Asset Type - ${(subAsset.equipmentSubType && subAsset.equipmentSubType.name) || '-'} <br> Asset Model - ${(subAsset.assetModel && subAsset.assetModel.name) || '-'} <br> Location - ${(poData[i].location && poData[i].location.name) || '-'}
<br> Owner - ${(subAsset.owner && subAsset.owner.name) || '-'} <br> Rate - ${(subEntry.rate !== undefined && subEntry.rate !== null) ? subEntry.rate : '-'} <br> ${(poData[i].client && 'Sub Location -') || ''} ${(poData[i].client && poData[i].client.name) || ''}</div>`
                }
            }

            htmlData += `<div style="text-align: left; border: 1px solid #000000;"><a href="/asset-tagging/${po._id}/${po.poNo}" target="_blank"><span style="color: tomato">Click here to Tag Assets for PO : ${po.poNo}</a> OR you can Tag later</div>`;

            poData.length && Swal.fire({
                width: 900,
                background: '#fff',
                backdrop: `
          rgba(0,0,123,0.4)
          left top
          no-repeat
        `,
                textAlign: 'left',
                text: 'Assets List',
                showCloseButton: true,
                html: htmlData,
            });
            history.push('/purchase-order');
            dispatch(getResource());
        } catch (error) {
            dispatch(fetchError(error));
            message.error(error.message);
            console.log("Error****:", error.message);
        }
    }
};

export const updateResource = (payload, id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            let formData = new FormData();

            const documentData = [];
            payload.documents.map((item, index) => {
                formData.append('files', item.file);
                let data = { ...item };
                delete data.file;
                documentData.push(data)
            });
            const assets = [];
            payload.assets && payload.assets.map((item, index) => {
                let data = { ...item };
                if (!data.client) {
                    delete data.client;
                }
                assets.push(data);
            });

            formData.append('documentData', JSON.stringify(documentData));
            if (assets.length) {
                formData.append('assets', JSON.stringify(assets));
            }
            if (payload.spareParts && payload.spareParts.length) {
                formData.append('spareParts', JSON.stringify(payload.spareParts));
            }

            Object.keys(payload).forEach(key => {
                if (key === 'documents') {
                    return
                }
                if (key === 'assets') {
                    return
                }
                if (key === 'spareParts') {
                    return
                }
                if (key === 'orderNumber' && (payload[key] === null || payload[key] === undefined)) {
                    return
                }
                if (key === 'orderDate' && (payload[key] === undefined)) {
                    return
                }
                if (key === 'grnNo' && (payload[key] === null || payload[key] === undefined)) {
                    return
                }
                formData.append(key, payload[key]);
            });


            const response = await axios.put(`/purchase-order/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            if (response && response.data.code === 404) {
                dispatch(fetchSuccess());
                return message.error(response.data.message);
            }

            const err = response.data.error && response.data.error.length ? "These asset's location and client cannot be updated because of ATA, ARN or Sales Invoice - " + response.data.error.join(', ') : '';
            if (err) {
                message.error(err, 10);
            }
            dispatch(fetchSuccess());
            history.push('/purchase-order');
            dispatch(getResource());
        } catch (error) {
            message.error(error.message);
            console.log("Error****:", error.message);
        }
    }
};

export const fetchResource = (id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.get(`/purchase-order/${id}`);
            dispatch(fetchSuccess());
            dispatch(fetchResourceSuccess({ data: response.data }));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const deleteResource = (id) => {
    console.log(id);
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.delete(`/purchase-order/${id}`);
            if (response && response.data) {
                if (response.data.code === '201') {
                    message.success(response.data.message);
                }
                if (response.data.code === '404') {
                    message.error(response.data.message);
                }
            }
            dispatch(fetchSuccess());
            dispatch(getResource());
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const deleteSpareInPurchaseInvoice = (id, purchaseOrderID) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            let formData = new FormData();
            formData.append('purchaseOrderID', JSON.stringify(purchaseOrderID));
            const res = await axios.put(`/common/delete-spare-in-purchase-invoice/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
            if (res && res.data.code === '201') {
                message.success(res.data.message);
            } else {
                message.error(res.data.message);
            }
            dispatch(fetchSuccess());
            dispatch(getResource());
            dispatch(fetchResource(purchaseOrderID));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const searchPOInGlobalData = (keyword = '') => {
    // console.log(keyword);
    let key = keyword.toLowerCase().indexOf('pi-', 0) === 0 ? keyword.toLowerCase() : '';
    return async dispatch => {
        dispatch(fetchStart());
        try {
            // console.log(key);
            const response = await axios.get(`/common/global-search/${key}`);
            // console.log(response.data);
            dispatch(fetchSuccess());
            dispatch(fetchPOSearchSuccess(response.data));
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    };
};

export const fetchPOSearchSuccess = (data) => {
    return {
        type: GET_GLOBAL_PARAMETER_PO_SEARCH_SUCCESS,
        data
    };
};

export const getAssetPurchaseReport = (payload) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await axios.post(`/purchase-order/asset-purchase-report`, payload);
            console.log('response', response.data)
            dispatch(fetchSuccess());
            dispatch(getAssetPurchaseReportSuccess(response.data));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
}

export const getAssetPurchaseReportSuccess = (data) => {
    return {
        type: GET_ASSET_PURCHASE_REPORT_SUCCESS,
        data
    };
}